import { createSelector } from 'reselect';

import { CHECKOUT_WISMO_TRIAL } from 'constants/monetateExperiments';
import { type ExperimentsState } from 'redux/modules/experiments/reducer';
import { getAllPayloads } from 'redux/modules/experiments/selectors';
import { getHashedCustomerId } from 'redux/modules/sessions/selectors';
import { getFeatureFlags } from 'utils/feature-flags';

// Define a temporary type for the getAllPayloads selector as it is still JS
type getAllPayloadsType<TPayload extends Record<string, unknown>> = (
  state: ExperimentsState,
) => Record<string, TPayload | string[] | undefined>;

const getWismoFeatureFlag = (): boolean => !!getFeatureFlags().checkout_wismo;
const getWismoTrialCustomerIds = createSelector(
  getAllPayloads as unknown as getAllPayloadsType<{ customers: string[] }>,
  payloads => {
    const payload = payloads[CHECKOUT_WISMO_TRIAL.experiment];
    return (Array.isArray(payload) ? payload : payload?.customers) || [];
  },
);

export const isWismoEnabled = createSelector(
  getHashedCustomerId,
  getWismoFeatureFlag,
  getWismoTrialCustomerIds,
  (hashedCustomerId, checkoutWismoEnabled, customerIds) => {
    return checkoutWismoEnabled || customerIds.includes(hashedCustomerId);
  },
);
